<template>
  <div>
    <b-row v-if="loading">
      <b-col class="text-center my-3">
        <b-spinner label="Loading..."></b-spinner>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col lg="4">
        <b-form-input
          id="headquarters"
          name="headquarters"
          v-model="code"
          aria-describedby="headquarters-feedback"
          placeholder="POSIADASZ KOD RABATOWY?"
        >
        </b-form-input>
      </b-col>
      <b-col v-if="!active" lg="2">
        <b-button @click="onSendCode"> Zatwierdź kod </b-button>
      </b-col>
      <b-col v-else lg="2">
        <b-button @click="onClearCode"> Wyczyść </b-button>
      </b-col>
      <b-col v-if="active" lg="12">
        <b-row>
          <b-col lg="4">
            <b-alert
              v-if="active"
              v-model="active"
              variant="success"
              dismissible
              class="mt-2 mb-3"
            >
              Twój kod został pomyślnie wykorzystany
            </b-alert>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'CodeDiscount',
  components: {},
  props: {},
  data() {
    return {
      code: '',
      active: false,
      loading: false,
    };
  },
  created() {
    this.loading = true;
    axios
      .get('/api/get-code-discount-cookie/')
      .then(({ data }) => {
        this.loading = false;
        if (data.length > 0) {
          this.active = true;
        }
        this.code = data;
      })
      .catch((error) => {});
  },
  computed: {},
  methods: {
    onSendCode() {
      this.loading = true;
      axios
        .get('/api/get-code-discount/' + this.code)
        .then(({ data }) => {
          this.loading = false;
          this.$emit('reloadProducts');
        })
        .catch((error) => {});
    },
    onClearCode() {
      this.loading = true;
      axios
        .get('/api/get-code-discount/0')
        .then(({ data }) => {
          this.loading = false;
          this.active = false;
          this.$emit('reloadProducts');
        })
        .catch((error) => {});
    },
  },
};
</script>

<style scoped></style>
